/**
 * Formats a number with thousands separators and adds CR/DR suffix.
 * @param x The number to format
 * @returns A formatted string representation of the number
 */
const format = (x: number): string => {
    const roundedX = (Math.round(x * 100) / 100).toFixed(2);
    const type = x === 0 ? "" : x < 0 ? "CR" : "DR";
    const absX = Math.abs(Number(roundedX));
    return absX.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + " " + type;
};

/**
 * Formats a number with thousands separators without CR/DR suffix.
 * @param x The number to format
 * @returns A formatted string representation of the number
 */
const formatAmount = (x: number): string => {
    const roundedX = (Math.round(x * 100) / 100).toFixed(2);
    const absX = Math.abs(Number(roundedX));
    return absX.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + " ";
};

export { format, formatAmount };